'use strict';
require('./_iter-define')(Number, 'Number', function (iterated) {
  this._l = +iterated;
  this._i = 0;
}, function () {
  var i = this._i++;
  var done = !(i < this._l);
  return { done: done, value: done ? undefined : i };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/core.number.iterator.js
// module id = ./node_modules/core-js/modules/core.number.iterator.js
// module chunks = 0